export const BUBBLE_BEAK_HEIGHT = 15;
export const BUBBLE_BEAK_WIDTH = 20;

export const CLUSTER_RADIUS = 45;

export const DETAIL_VIEW_URL = "?view=details";

export const GESTURE_SETTING = "cooperative";

export const MARKER_X_DIMENSION = 20;
export const MARKER_Y_DIMENSION = 20;

export const PROPERTIES_PER_PAGE = 5;

// bounds of NY + NJ
export const NY_AREA_BOUNDS = {
  eastLng: -71.86,
  northLat: 45.01,
  southLat: 38.93,
  westLng: -79.76
};
